<section class="page__header">
  <custom-app-bar
    [title]="'delete_delivery_point.title' | translate"
    [hasCloseButton]="true"
    [hasSafeArea]="false"
  >
  </custom-app-bar>
</section>

<section class="page__content">
  <p class="text">{{ "delete_delivery_point.text" | translate }}</p>
  <button
    customButton
    size="large"
    expand="full"
    [disabled]="isDeleteDeliveryPointLoading$ | async"
    [isLoading]="isDeleteDeliveryPointLoading$ | async"
    (click)="deleteDeliveryPoint()"
  >
    {{ "delete_delivery_point.yes" | translate }}
  </button>
  <button
    customButton
    size="large"
    expand="full"
    appearance="ghost"
    (click)="close()"
  >
    {{ "delete_delivery_point.no" | translate }}
  </button>
</section>
